export type CanonicalRole = 'SUPER_ADMIN' | 'ADMIN' | 'SUPPORT' | 'LANDLORD' | 'PROPERTY_MANAGER' | 'PROPERTY_OWNER' | 'TENANT' | 'VENDOR' | '';

function extractRoleValue(role: unknown): string {
  if (typeof role === 'string') {
    return role;
  }

  if (role && typeof role === 'object') {
    const roleRecord = role as Record<string, unknown>;
    if (typeof roleRecord['name'] === 'string') {
      return roleRecord['name'] as string;
    }
    if (typeof roleRecord['role'] === 'string') {
      return roleRecord['role'] as string;
    }
  }

  return '';
}

export function normalizeRole(role: unknown): CanonicalRole {
  const rawValue = extractRoleValue(role).trim();
  if (!rawValue) {
    return '';
  }

  let normalized = rawValue.toUpperCase();
  if (normalized.startsWith('ROLE_')) {
    normalized = normalized.substring(5);
  }

  normalized = normalized.replace(/[\s-]+/g, '_');
  if (normalized === 'SUPERADMIN') {
    return 'SUPER_ADMIN';
  }

  if (normalized === 'SUPER_ADMIN' || normalized === 'ADMIN' || normalized === 'SUPPORT' || normalized === 'LANDLORD' || normalized === 'PROPERTY_MANAGER' || normalized === 'PROPERTY_OWNER' || normalized === 'TENANT' || normalized === 'VENDOR') {
    return normalized;
  }

  return '';
}

export function isSuperAdminRole(role: unknown): boolean {
  return normalizeRole(role) === 'SUPER_ADMIN';
}

export function isAdminRole(role: unknown): boolean {
  const normalized = normalizeRole(role);
  return normalized === 'ADMIN' || normalized === 'SUPER_ADMIN';
}

export function isLandlordRole(role: unknown): boolean {
  const normalized = normalizeRole(role);
  return normalized === 'LANDLORD' || normalized === 'PROPERTY_MANAGER';
}

export function isTenantRole(role: unknown): boolean {
  return normalizeRole(role) === 'TENANT';
}

export function isVendorRole(role: unknown): boolean {
  return normalizeRole(role) === 'VENDOR';
}

export function usesLandlordDashboard(role: unknown): boolean {
  return isLandlordRole(role);
}
